import React from "react";

import NoDataFound from "../common/NoDataFound";
import NextImage from "../common/NextImage";
import { uniqueId, linkName, getUrlSport } from "../../utils/generalLiveCenter";

const ScoreCard = ({
  data,
  dictionary,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  sport = "cricket",
}) => {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const getPlayerUrl = (player) => {
    if (!dataClient || !player?.player?.pid) return null;
    const basePath = websiteBaseUrl || "";
    const pathSegment = dataPath || getUrlSport(sport);
    return `${basePath}/${pathSegment}/player/${linkName(player?.player?.nm)}/${player?.player?.pid}/info`;
  };
  const hasData =
    data && (data.batting?.length > 0 || data.bowling?.length > 0);
  return (
    <>
      {hasData ? (
        <>
          <div className="global_table cr_macth_scorecard">
            <table>
              <thead>
                <tr>
                  <th>
                    <strong>{dictionary?.batsman || "Batsman"} </strong>
                  </th>
                  <th>
                    <strong>R</strong>
                  </th>
                  <th>
                    <strong>B</strong>
                  </th>
                  <th>
                    <strong>4s</strong>
                  </th>
                  <th>
                    <strong>6s</strong>
                  </th>
                  <th>
                    <strong>SR</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.batting?.map((player, i) => (
                  <tr
                    key={uniqueId(i)}
                    className={`${player?.ty === "Not Out" || player?.actv === 1
                        ? "not_out"
                        : ""
                      }`}
                  >
                    <td>
                      <div className="bastman_td">
                        {getPlayerUrl(player) ? (
                          <a href={getPlayerUrl(player)} className="name player-link">
                            {player?.player?.nm}{" "}
                            {player?.is_wick_k ? " (WK)" : null}
                            {player?.is_cap ? " (C)" : null}
                            {player?.actv === 1 ? (
                              <span className="bat_ico">
                                <NextImage
                                  src={`${baseURL}/public/assets/images/Bat1.png`}
                                  width={15}
                                  height={14}
                                  alt="bat"
                                />
                              </span>
                            ) : null}
                          </a>
                        ) : (
                          <span className="name">
                            {player?.player?.nm}{" "}
                            {player?.is_wick_k ? " (WK)" : null}
                            {player?.is_cap ? " (C)" : null}
                            {player?.actv === 1 ? (
                              <span className="bat_ico">
                                <NextImage
                                  src={`${baseURL}/public/assets/images/Bat1.png`}
                                  width={15}
                                  height={14}
                                  alt="bat"
                                />
                              </span>
                            ) : null}
                          </span>
                        )}
                        <span className="bow_inf">
                          {player?.fielder &&
                            ` ${player?.ty === "Catch OUT " ? "c " : "o "} ${player?.fielder?.nm
                            } `}
                          {player?.ty}
                          {player?.bowler && ` b ${player?.bowler?.nm}`}
                        </span>
                      </div>
                    </td>
                    <td>{player?.ft}</td>
                    <td>{player?.bls}</td>
                    <td>{player?.fr}</td>
                    <td>{player?.sx}</td>
                    <td>{Number(player?.rr).toFixed(2)}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={6}>
                    <div className="toal_plyer_cr">
                      <span>
                        <span> {dictionary?.total || "Total"} :</span>{" "}
                        <strong>{data?.sc}</strong>
                      </span>
                      <span>
                        <span> {dictionary?.extras || "Extras"}:</span>{" "}
                        <strong>{data?.extr}</strong>
                      </span>
                      <span>
                        <span>B:</span> <strong>{data?.b}</strong>
                      </span>
                      <span>
                        <span>LB:</span> <strong>{data?.lb}</strong>
                      </span>
                      <span>
                        <span>NB:</span>
                        <strong>{data?.nb}</strong>
                      </span>
                      <span>
                        <span>W:</span> <strong>{data?.w}</strong>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="global_table cr_macth_scorecard">
            <table>
              <thead>
                <tr>
                  <th>
                    <strong> {dictionary?.bowlers || "Bowlers"}</strong>
                  </th>
                  <th>
                    <strong>O</strong>
                  </th>
                  <th>
                    <strong>M</strong>
                  </th>
                  <th>
                    <strong>R</strong>
                  </th>
                  <th>
                    <strong>W</strong>
                  </th>
                  <th>
                    <strong>NB</strong>
                  </th>
                  <th>
                    <strong>WD</strong>
                  </th>
                  <th>
                    <strong>ER</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.bowling?.map((player, i) => (
                  <tr
                    key={i}
                    className={`${player?.actv === 1 ? "not_out" : ""}`}
                  >
                    <td>
                      {getPlayerUrl(player) ? (
                        <a href={getPlayerUrl(player)} className="name player-link">
                          {player?.player?.nm}
                          {player?.actv === 1 ? (
                            <span className="bat_ico">
                              <NextImage
                                src={`${baseURL}/public/assets/images/cricket_Ball.png`}
                                width={14}
                                height={14}
                                alt="ball"
                              />
                            </span>
                          ) : null}
                        </a>
                      ) : (
                        <span className="name">
                          {player?.player?.nm}
                          {player?.actv === 1 ? (
                            <span className="bat_ico">
                              <NextImage
                                src={`${baseURL}/public/assets/images/cricket_Ball.png`}
                                width={14}
                                height={14}
                                alt="ball"
                              />
                            </span>
                          ) : null}
                        </span>
                      )}
                    </td>
                    <td>{player?.ovs}</td>
                    <td>{player?.mdns}</td>
                    <td>{player?.ft}</td>
                    <td>{player?.nb}</td>
                    <td>{player?.wd}</td>
                    <td>{player?.wckts}</td>
                    <td>{Number(player?.rr).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <NoDataFound
          text={`${dictionary?.norecordfound || "no record found"}!`}
        />
      )}
    </>
  );
};

export default ScoreCard;
